// extracted by css-extract-rspack-plugin
export default {"summaryContainer":"SubIssuesSummary-module__summaryContainer__hR7zoMr"};